export enum NightAnalysisTemplateTypeValues {
    Impression = "Impression",
    Recommendation = "Recommendation",
}
